<template>
  <div class="app-main-content  mailing-address">
    <div class="grid-view">
      <div class="main-content">
        <div class="section">
          <div class="filters">
            <el-form :inline="true" label-width="100px" label-position="left">
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('baseInfo.mailingAddress.office')">
                  <el-select v-model="searchConditions.officeId" style="width: 170px;" filterable no="1">
                    <el-option
                      v-for="office in currentOfficeList"
                      :key="office.uuid"
                      :value="office.officeId"
                      :label="office.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.lobType')">
                  <el-select
                    v-model="searchConditions.lob"
                    no="2"
                    :placeholder="$t('common.tips.pleaseChoose')"
                    clearable
                    style="width: 170px;"
                  >
                    <el-option
                      v-for="item in itemTypeArray"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.partner')">
                  <cargo-company-select
                    no="3"
                    :method-params="{customer:true, active:true, fba:true}"
                    :check-credit="true"
                    :default-value="searchConditions.partnerId||''"
                    style="flex: 1;"
                    :data-filter-function="customerIdFilter"
                    @change="p=>{searchConditions.partnerId=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.fbaWarehouseCode')">
                  <cargo-advance-select
                    no="4"
                    :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                    filterable
                    :fields="['warehouseCode']"
                    :callback-params="{key:'warehouseCode'}"
                    callback-method-type="value"
                    tag-value="warehouseCode"
                    tag-name="warehouseCode"
                    :default-value="searchConditions.warehouseCode"
                    style="width:170px;"
                    @parentCallBack="item=>searchConditions.warehouseCode=item.value"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="app-main-inner-row">
            <div class="triggers">
              <el-button no="5" type="primary" size="mini" @click="fetchMailingAddressList">{{ $t('common.btn.query') }}</el-button>
              <el-button no="6" type="primary" @click="popMailingAddressAddDialog">{{ $t('common.btn.new') }}</el-button>
              <el-button no="7" type="primary" @click="popMailingAddressEditDialog">{{ $t('common.btn.edit') }}</el-button>
              <el-button no="8" type="danger" @click="toBatchDel">{{ $t('common.btn.delete') }}</el-button>
              <cargo-grid-state-btn no="9" :grid-params="gridParams" config-module="100802" />
            </div>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="100802"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            config-module="100802"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchMailingAddressList"
          />
        </div>
      </div>
    </div>
    <!-- 添加收发通地址 -->
    <el-dialog
      v-if="mailingAddressMaintainDialog.isShow"
      v-el-drag-dialog
      :visible.sync="mailingAddressMaintainDialog.isShow"
      :close-on-click-modal="false"
      :title="mailingAddressMaintainDialog.title"
      width="1100px"
    >
      <el-scrollbar style="height: 100%">
        <div class="app-main-inner-row">
          <el-form ref="mailingAddressAddForm" :model="mailingAddressForm" :inline="true" label-width="100px" label-position="left">
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('baseInfo.mailingAddress.lobType')">
                <el-select
                  v-model="mailingAddressForm.lob"
                  no="10"
                  :placeholder="$t('common.tips.pleaseChoose')"
                  clearable
                  style="width: 170px;"
                >
                  <el-option
                    v-for="item in itemTypeArray"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baseInfo.mailingAddress.partner')">
                <cargo-company-select
                  no="11"
                  :method-params="{customer:true, active:true, fba:true}"
                  :check-credit="true"
                  :default-value="mailingAddressForm.partnerId||''"
                  style="flex: 1;"
                  :data-filter-function="customerIdFilter"
                  @change="p=>{mailingAddressForm.partnerId=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('baseInfo.mailingAddress.fbaWarehouseCode')">
                <cargo-advance-select
                  no="12"
                  :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                  filterable
                  :fields="['warehouseCode']"
                  :callback-params="{key:'warehouseCode'}"
                  callback-method-type="value"
                  tag-name="warehouseCode"
                  :default-value="mailingAddressForm.warehouseCode"
                  style="width:170px;"
                  @parentCallBack="p=>mailingAddressForm.warehouseCode=p.value"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="app-main-inner-row">
          <el-form v-model="mailingAddressForm" :inline="true" label-width="85px" label-position="left" style="height:400px;min-height:400px;">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-tag size="medium" class="tag-w">{{ $t('baseInfo.mailingAddress.shipper') }}</el-tag>
                <div class="el-form-item-wrapper el-form-item-group">
                  <div v-show="!formatManifestInfo" :style="{ position: 'relative', height: $selectByLang('550px', '550px', '550px', '650px', '650px', '650px') }">
                    <el-form-item :label="$t('SeaExport.CompanyName')">
                      <el-input v-model="mailingAddressForm.shipperEnterpriseName" v-uppercase no="13" :placeholder="$t('SeaExport.CompanyName')" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.contactName')">
                      <el-input v-model="mailingAddressForm.shipperContactName" v-uppercase no="14" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                      <el-input v-model="mailingAddressForm.shipperContactTel" v-uppercase no="15" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_email')">
                      <el-input v-model="mailingAddressForm.shipperContactEmail" v-uppercase no="16" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Fax')">
                      <el-input v-model="mailingAddressForm.shipperFax" v-uppercase no="17" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.ZIP')">
                      <el-input v-model="mailingAddressForm.shipperZipCode" v-uppercase no="18" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Country')">
                      <cargo-advance-select
                        no="19"
                        :select-type="selectTypeNames.basic_data_Country"
                        filterable
                        :callback-params="{key:'shipperCountryCode'}"
                        callback-method-type="value"
                        :default-value="mailingAddressForm.shipperCountryCode"
                        :style="mailingAddressForm.shipperCountryCode ? 'width: 85%;' : 'width: 100%;'"
                        @parentCallBack="selectCargoItem"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.province')">
                      <!--                      <cargo-advance-select
                        :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                        filterable
                        :callback-params="{key:'shipperProvinceCode'}"
                        callback-method-type="value"
                        :static-options="provinceList"
                        :default-value="mailingAddressForm.shipperProvinceCode"
                        @parentCallBack="selectCargoItem"
                      />-->
                      <el-input v-model="mailingAddressForm.shipperProvinceCode" v-uppercase no="20" />
                    </el-form-item>
                    <el-form-item :label="$t('route.city')">
                      <!--                      <cargo-advance-select
                        :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                        filterable
                        :callback-params="{key:'shipperCityCode'}"
                        callback-method-type="value"
                        :static-options="cityList"
                        :default-value="mailingAddressForm.shipperCityCode"
                        @parentCallBack="selectCargoItem"
                      />-->
                      <el-input v-model="mailingAddressForm.shipperCityCode" v-uppercase no="21" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.addr1')">
                      <el-input v-model="mailingAddressForm.shipperAddress1" v-uppercase no="22" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.addr2')">
                      <el-input v-model="mailingAddressForm.shipperAddress2" v-uppercase no="23" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.addr3')">
                      <el-input v-model="mailingAddressForm.shipperAddress3" v-uppercase no="24" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.eoriNo')">
                      <el-input v-model="mailingAddressForm.shipperEoriNo" v-uppercase no="25" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.taxNo')">
                      <el-input v-model="mailingAddressForm.shipperVatNo" v-uppercase style="width:145px;" />
                      <el-select v-model="mailingAddressForm.shipperVatNoType" style="width:50px;padding-left: 2px;" placeholder="" no="26">
                        <el-option
                          v-for="item in SystemConstants.VAT_NO_TYPES"
                          :key="item.code"
                          :label="item.code"
                          :value="item.code"
                        />
                      </el-select>
                    </el-form-item>
                    <div class="float-btn-wrapper">
                      <el-button no="27" type="info" @click="syncFormatInfoToOrder('shipper')">{{ $t('CargoMsg.Cargo_Format') + $t('CargoMsg.Cargo_ShipperInfo') }}</el-button>
                    </div>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.shipperLine1" v-uppercase no="28" :readonly="readonly" class="input-w" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.shipperLine2" v-uppercase no="29" :readonly="readonly" class="input-w" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.shipperLine3" v-uppercase no="30" :readonly="readonly" class="input-w" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.shipperLine4" v-uppercase no="31" :readonly="readonly" class="input-w" />
                    </el-form-item>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <el-tag size="medium" class="tag-w">{{ $t('baseInfo.mailingAddress.consignee') }}</el-tag>
                <div class="el-form-item-wrapper el-form-item-group">
                  <div v-show="!formatManifestInfo" :style="{ position: 'relative', height: $selectByLang('550px', '550px', '550px', '650px', '650px', '650px') }">
                    <el-form-item :label="$t('SeaExport.CompanyName')">
                      <el-input v-model="mailingAddressForm.consigneeEnterpriseName" v-uppercase no="32" :placeholder="$t('SeaExport.CompanyName')" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.contactName')">
                      <el-input v-model="mailingAddressForm.consigneeContactName" v-uppercase no="33" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                      <el-input v-model="mailingAddressForm.consigneeContactTel" v-uppercase no="34" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_email')">
                      <el-input v-model="mailingAddressForm.consigneeContactEmail" v-uppercase no="35" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Fax')">
                      <el-input v-model="mailingAddressForm.consigneeFax" v-uppercase no="36" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.ZIP')">
                      <el-input v-model="mailingAddressForm.consigneeZipCode" v-uppercase no="37" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Country')">
                      <cargo-advance-select
                        no="38"
                        :select-type="selectTypeNames.basic_data_Country"
                        filterable
                        :callback-params="{key:'consigneeCountryCode'}"
                        callback-method-type="value"
                        :default-value="mailingAddressForm.consigneeCountryCode"
                        :style="mailingAddressForm.consigneeCountryCode ? 'width: 85%;' : 'width: 100%;'"
                        @parentCallBack="selectCargoItem"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.province')">
                      <!--                      <cargo-advance-select
                                              :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                                              filterable
                                              :callback-params="{key:'consigneeProvinceCode'}"
                                              callback-method-type="value"
                                              :static-options="provinceList"
                                              :default-value="mailingAddressForm.consigneeProvinceCode"
                                              @parentCallBack="selectCargoItem"
                                            />-->
                      <el-input v-model="mailingAddressForm.consigneeProvinceCode" v-uppercase no="39" />
                    </el-form-item>
                    <el-form-item :label="$t('route.city')">
                      <!--                      <cargo-advance-select
                                              :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                                              filterable
                                              :callback-params="{key:'consigneeCityCode'}"
                                              callback-method-type="value"
                                              :static-options="cityList"
                                              :default-value="mailingAddressForm.consigneeCityCode"
                                              @parentCallBack="selectCargoItem"
                                            />-->
                      <el-input v-model="mailingAddressForm.consigneeCityCode" v-uppercase no="40" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.addr1')">
                      <el-input v-model="mailingAddressForm.consigneeAddress1" v-uppercase no="41" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.addr2')">
                      <el-input v-model="mailingAddressForm.consigneeAddress2" v-uppercase no="42" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.addr3')">
                      <el-input v-model="mailingAddressForm.consigneeAddress3" v-uppercase no="43" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.eoriNo')">
                      <el-input v-model="mailingAddressForm.consigneeEoriNo" v-uppercase no="44" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.taxNo')">
                      <el-input v-model="mailingAddressForm.consigneeVatNo" v-uppercase no="45" style="width:145px;" />
                      <el-select v-model="mailingAddressForm.consigneeVatNoType" style="width:50px;padding-left: 2px;" placeholder="" no="46">
                        <el-option
                          v-for="item in SystemConstants.VAT_NO_TYPES"
                          :key="item.code"
                          :label="item.code"
                          :value="item.code"
                        />
                      </el-select>
                    </el-form-item>
                    <div class="float-btn-wrapper">
                      <el-button no="47" type="info" @click="syncFormatInfoToOrder('consignee')">{{ $t('CargoMsg.Cargo_Format') + $t('CargoMsg.Cargo_ConsigneeInfo') }}</el-button>
                    </div>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.consigneeLine1" v-uppercase no="48" :readonly="readonly" class="input-w" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.consigneeLine2" v-uppercase no="49" :readonly="readonly" class="input-w" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.consigneeLine3" v-uppercase no="50" :readonly="readonly" class="input-w" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.consigneeLine4" v-uppercase no="51" :readonly="readonly" class="input-w" />
                    </el-form-item>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <el-tag size="medium" class="tag-w">{{ $t('baseInfo.mailingAddress.notify') }}</el-tag>
                <div class="el-form-item-wrapper el-form-item-group">
                  <div v-show="!formatManifestInfo" :style="{ position: 'relative', height: $selectByLang('550px', '550px', '550px', '650px', '650px', '650px') }">
                    <el-form-item :label="$t('SeaExport.CompanyName')">
                      <el-input v-model="mailingAddressForm.notifyEnterpriseName" v-uppercase no="52" :placeholder="$t('SeaExport.CompanyName')" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.contactName')">
                      <el-input v-model="mailingAddressForm.notifyContactName" v-uppercase no="53" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                      <el-input v-model="mailingAddressForm.notifyContactTel" v-uppercase no="54" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_email')">
                      <el-input v-model="mailingAddressForm.notifyContactEmail" v-uppercase no="55" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Fax')">
                      <el-input v-model="mailingAddressForm.notifyFax" v-uppercase no="56" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.ZIP')">
                      <el-input v-model="mailingAddressForm.notifyZipCode" v-uppercase no="57" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Country')">
                      <cargo-advance-select
                        no="58"
                        :select-type="selectTypeNames.basic_data_Country"
                        filterable
                        :callback-params="{key:'notifyCountryCode'}"
                        callback-method-type="value"
                        :default-value="mailingAddressForm.notifyCountryCode"
                        :style="mailingAddressForm.notifyCountryCode ? 'width: 85%;' : 'width: 100%;'"
                        @parentCallBack="selectCargoItem"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.province')">
                      <!--                      <cargo-advance-select
                                              :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                                              filterable
                                              :callback-params="{key:'notifyProvinceCode'}"
                                              callback-method-type="value"
                                              :static-options="provinceList"
                                              :default-value="mailingAddressForm.notifyProvinceCode"
                                              @parentCallBack="selectCargoItem"
                                            />-->
                      <el-input v-model="mailingAddressForm.notifyProvinceCode" v-uppercase no="59" />
                    </el-form-item>
                    <el-form-item :label="$t('route.city')">
                      <!--                      <cargo-advance-select
                                              :select-type="selectTypeNames.basic_data_AdministrativeDivision"
                                              filterable
                                              :callback-params="{key:'notifyCityCode'}"
                                              callback-method-type="value"
                                              :static-options="cityList"
                                              :default-value="mailingAddressForm.notifyCityCode"
                                              @parentCallBack="selectCargoItem"
                                            />-->
                      <el-input v-model="mailingAddressForm.notifyCityCode" v-uppercase no="60" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.addr1')">
                      <el-input v-model="mailingAddressForm.notifyAddress1" v-uppercase no="61" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.addr2')">
                      <el-input v-model="mailingAddressForm.notifyAddress2" v-uppercase no="62" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.addr3')">
                      <el-input v-model="mailingAddressForm.notifyAddress3" v-uppercase no="63" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.eoriNo')">
                      <el-input v-model="mailingAddressForm.notifyEoriNo" v-uppercase no="64" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.taxNo')">
                      <el-input v-model="mailingAddressForm.notifyVatNo" v-uppercase no="65" style="width:145px;" />
                      <el-select v-model="mailingAddressForm.notifyVatNoType" no="66" style="width:50px;padding-left: 2px;" placeholder="">
                        <el-option
                          v-for="item in SystemConstants.VAT_NO_TYPES"
                          :key="item.code"
                          :label="item.code"
                          :value="item.code"
                        />
                      </el-select>
                    </el-form-item>
                    <div class="float-btn-wrapper">
                      <el-button no="67" type="info" @click="syncFormatInfoToOrder('notify')">{{ $t('CargoMsg.Cargo_Format') + $t('CargoMsg.Cargo_NotifyInfo') }}</el-button>
                    </div>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.notifyLine1" v-uppercase no="68" :readonly="readonly" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.notifyLine2" v-uppercase no="69" :readonly="readonly" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.notifyLine3" v-uppercase no="70" :readonly="readonly" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.notifyLine4" v-uppercase no="71" :readonly="readonly" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-scrollbar>
      <div slot="footer">
        <el-button no="72" type="primary" @click="submitMailingAddress">{{ $t('common.btn.save') }}</el-button>
        <el-button no="73" @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import {
  getMailingAddressList, findMailingAddressByUuid, addMailingAddress, updateMailingAddress, batchDelMailingAddress
} from '@/api/partner/fbaMailingAddress'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'FbaMailingAddress',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  data() {
    return {
      SystemConstants,
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      searchConditions: {
        lob: '',
        partnerId: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        officeId: this.$store.getters.currentOfficeId,
        warehouseCode: ''
      },
      podSelectOpt: {
        searchFormDisable: false,
        maintainFormDisable: false
      },
      itemTypeArray: [
        {
          value: 'QB',
          name: this.$t('constant.all')
        },
        ...this.$constantI18n('fbaLobSource')
      ],
      gridParams: {},
      gridOptions: {
        rowHeight: 130,
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.partner'),
          field: 'partnerId', width: 150,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          },
          tooltipValueGetter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
          field: 'warehouseCode', width: 150,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_OverseaWarehouse, 'warehouseCode', params.value) : ''
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.lobType'),
          field: 'lob', width: 150,
          valueFormatter: (params) => {
            if (params.value) {
              const type = this.$constantI18n('allLobSource').find(item => {
                return item.value === params.value
              })
              return type ? type.name : params.value
            }
            return ''
          }
        },
        {
          headerName: this.$t('SeaExport.Shipper') + this.$t('SeaExport.CompanyName'), width: 150,
          field: 'shipperEnterpriseName',
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('SeaExport.Consignee') + this.$t('SeaExport.CompanyName'), width: 150,
          field: 'consigneeEnterpriseName',
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('SeaExport.NotifyParty') + this.$t('SeaExport.CompanyName'), width: 150,
          field: 'notifyEnterpriseName',
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.shipperInfo'), width: 150,
          field: 'shipperInfo',
          cellRenderer: (params) => {
            return this.multipleDataRellRenderer(params, 'shipper')
          },
          tooltipValueGetter: (params) => {
            return this.multipleDataRellRenderer(params, 'notify')
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.consigneeInfo'), width: 150,
          field: 'consigneeInfo',
          cellRenderer: (params) => {
            return this.multipleDataRellRenderer(params, 'consignee')
          },
          tooltipValueGetter: (params) => {
            return this.multipleDataRellRenderer(params, 'notify')
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.notifyInfo'), width: 150,
          field: 'notifyInfo',
          cellRenderer: (params) => {
            return this.multipleDataRellRenderer(params, 'notify')
          },
          tooltipValueGetter: (params) => {
            return this.multipleDataRellRenderer(params, 'notify')
          }
        }],
      mailingAddressMaintainDialog: {
        isShow: false,
        isEdit: true,
        title: ''
      },
      initMailingAddressForm: {
        officeId: '',
        lob: '',
        partnerId: '',
        warehouseCode: '',
        // 发货人相关
        shipperEnterpriseName: '',
        shipperCountryCode: '',
        shipperCountryName: '',
        shipperProvinceCode: '',
        shipperProvinceName: '',
        shipperCityCode: '',
        shipperCityName: '',
        shipperZipCode: '',
        shipperFax: '',
        shipperContactName: '',
        shipperContactTel: '',
        shipperContactEmail: '',
        shipperAddress1: '',
        shipperAddress2: '',
        shipperAddress3: '',
        shipperEoriNo: '',
        shipperVatNo: '',
        shipperVatNoType: '',
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        // 收货人相关
        consigneeEnterpriseName: '',
        consigneeCountryCode: '',
        consigneeCountryName: '',
        consigneeProvinceCode: '',
        consigneeProvinceName: '',
        consigneeCityCode: '',
        consigneeCityName: '',
        consigneeZipCode: '',
        consigneeFax: '',
        consigneeContactName: '',
        consigneeContactTel: '',
        consigneeContactEmail: '',
        consigneeAddress1: '',
        consigneeAddress2: '',
        consigneeAddress3: '',
        consigneeEoriNo: '',
        consigneeVatNo: '',
        consigneeVatNoType: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        // 通知人相关
        notifyEnterpriseName: '',
        notifyCountryCode: '',
        notifyCountryName: '',
        notifyProvinceCode: '',
        notifyProvinceName: '',
        notifyCityCode: '',
        notifyCityName: '',
        notifyZipCode: '',
        notifyFax: '',
        notifyContactName: '',
        notifyContactTel: '',
        notifyContactEmail: '',
        notifyAddress1: '',
        notifyAddress2: '',
        notifyAddress3: '',
        notifyEoriNo: '',
        notifyVatNo: '',
        notifyVatNoType: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: ''
      },
      mailingAddressForm: null,
      isShowMailingAddressMaintain: false,
      formatManifestInfo: false,
      countryList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      readonly: true
    }
  },
  computed: {
    url() {
      return URL
    },
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  mounted() {
    this.fetchMailingAddressList()
  },
  methods: {
    selectCargoItem(item) {
      this.mailingAddressForm[item.key] = item.value
      if (item.key === 'shipperCountryCode') {
        // 根据二字码查询国家
        // let countryUuid = ''
        if (this.mailingAddressForm.shipperCountryCode) {
          const country = getObjectByCache(basicCacheKeys.basic_data_Country, 'code', this.mailingAddressForm.shipperCountryCode)
          if (country) {
            // countryUuid = country.uuid
            this.mailingAddressForm.shipperCountryName = country.chineseName
          }
        }
        // 国家为空清空省市
        if (!this.mailingAddressForm.shipperCountryCode) {
          this.mailingAddressForm.shipperCountryName = ''
          // this.mailingAddressForm.shipperProvinceCode = ''
          // this.mailingAddressForm.shipperProvinceName = ''
          // this.mailingAddressForm.shipperCityCode = ''
          // this.mailingAddressForm.shipperCityName = ''
        }
        // 初始化省份信息
        // this.getDivisionByParentId(countryUuid, 1)
      } else if (item.key === 'shipperProvinceCode') {
        // this.getDivisionByParentCode(this.mailingAddressForm.shipperProvinceCode, 2)
        // 省为空清空市
        // if (!this.mailingAddressForm.shipperProvinceCode) {
        //   this.mailingAddressForm.shipperProvinceName = ''
        //   this.mailingAddressForm.shipperCityCode = ''
        //   this.mailingAddressForm.shipperCityName = ''
        // }
      } else if (item.key === 'shipperCityCode') {
        // 省为空清空市
        // if (!this.mailingAddressForm.shipperCityCode) {
        //   this.mailingAddressForm.shipperCityName = ''
        // }
      } else if (item.key === 'consigneeCountryCode') {
        // 根据二字码查询国家
        // let countryUuid = ''
        if (this.mailingAddressForm.consigneeCountryCode) {
          const country = getObjectByCache(basicCacheKeys.basic_data_Country, 'code', this.mailingAddressForm.consigneeCountryCode)
          if (country) {
            // countryUuid = country.uuid
            this.mailingAddressForm.consigneeCountryName = country.chineseName
          }
        }
        // 国家为空清空省市
        if (!this.mailingAddressForm.consigneeCountryCode) {
          this.mailingAddressForm.consigneeCountryName = ''
        }
      } else if (item.key === 'notifyCountryCode') {
        // 根据二字码查询国家
        // let countryUuid = ''
        if (this.mailingAddressForm.notifyCountryCode) {
          const country = getObjectByCache(basicCacheKeys.basic_data_Country, 'code', this.mailingAddressForm.notifyCountryCode)
          if (country) {
            // countryUuid = country.uuid
            this.mailingAddressForm.notifyCountryName = country.chineseName
          }
        }
        // 国家为空清空省市
        if (!this.mailingAddressForm.notifyCountryCode) {
          this.mailingAddressForm.notifyCountryName = ''
        }
      }
    },
    // 根据parentId获取区域信息 parentId 父级ID type 1.省份;2.城市;3.地区
    getDivisionByParentId(parentId, type) {
      let data = []
      if (parentId) {
        data = getObjectByCache(basicCacheKeys.basic_data_AdministrativeDivision, 'parentId', parentId)
      }
      switch (type) {
        case 1: this.provinceList = data; break
        case 2: this.cityList = data; break
        case 3: this.districtList = data; break
        default: break
      }
    },
    /**
     * 根据父级代码获取区域信息
     * @param parentCode 父级代码
     * @param type 2.城市;3.地区
     */
    getDivisionByParentCode(parentCode, type) {
      let provinces = []
      let cities = []
      switch (type) {
        case 2:
          provinces = this.provinceList.filter(p => p.code === parentCode)
          if (provinces.length > 0) {
            this.getDivisionByParentId(provinces[0].uuid, type)
          } else {
            this.cityList = []
          }
          break
        case 3:
          cities = this.cityList.filter(p => p.code === parentCode)
          if (cities.length > 0) {
            this.getDivisionByParentId(cities[0].uuid, type)
          } else {
            this.districtList = []
          }
          break
        default: break
      }
    },
    // 收发通显示列显示
    multipleDataRellRenderer(params, handleType) {
      const addr = params.data
      let curInfo = ''
      switch (handleType) {
        case 'shipper':
          if (addr.shipperEnterpriseName) {
            curInfo += addr.shipperEnterpriseName
          }
          if (addr.shipperAddress1) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.shipperAddress1
          }
          addr.shipperLine3 = (addr.shipperCityCode +
            addr.shipperProvinceCode +
            addr.shipperCountryCode +
            addr.shipperZipCode)
          if (addr.shipperLine3) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.shipperLine3
          }
          if (addr.notifyContactTel) {
            if (curInfo) curInfo += '<br/>'
            curInfo += ('TEL:' + addr.shipperContactTel)
          }
          break
        case 'consignee':
          if (addr.consigneeEnterpriseName) {
            curInfo += addr.consigneeEnterpriseName
          }
          if (addr.consigneeAddress1) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.consigneeAddress1
          }
          addr.consigneeLine3 = (addr.consigneeCityCode +
            addr.consigneeProvinceCode +
            addr.consigneeCountryCode +
            addr.consigneeZipCode)
          if (addr.consigneeLine3) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.consigneeLine3
          }
          if (addr.consigneeContactTel) {
            if (curInfo) curInfo += '<br/>'
            curInfo += ('TEL:' + addr.consigneeContactTel)
          }
          break
        case 'notify':
          if (addr.notifyEnterpriseName) {
            curInfo += addr.notifyEnterpriseName
          }
          if (addr.notifyAddress1) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.notifyAddress1
          }
          addr.notifyLine3 = (addr.notifyCityCode +
            addr.notifyProvinceCode +
            addr.notifyCountryCode +
            addr.notifyZipCode)
          if (addr.notifyLine3) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.notifyLine3
          }
          if (addr.notifyContactTel) {
            if (curInfo) curInfo += '<br/>'
            curInfo += ('TEL:' + addr.notifyContactTel)
          }
          break
        default:
          break
      }
      return curInfo
    },
    ladingBill(value) {
      this.mailingAddressForm.consigneeEnterpriseName = value ? 'TO ORDER' : ''
    },
    toBatchDel() {
      const self = this
      getGridSelectedIds(this.gridOptions, 'uuid').then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        }
        this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          batchDelMailingAddress(ids).then(res => {
            self.fetchMailingAddressList()
            this.$message.success(this.$t('common.tips.deleteSuccess'))
          })
        }).catch(() => {
          this.$message.info(this.$t('common.tips.deleteFail'))
        })
      })
    },
    getMailingAddressSelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length > 0) {
        return selectedRows
      }
      this.$message.error(this.$t('common.tips.hasOneAtleast'))
    },
    fetchMailingAddressList() {
      const self = this
      const params = { ...this.searchConditions }
      params.lob = (params.lob && params.lob.startsWith('FBA')) ? params.lob.split('FBA')[1] : params.lob
      this.fullscreenLoading = getLoading4Cxt()
      getMailingAddressList(params).then(res => {
        self.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.total = Number(res.data.total)
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    popMailingAddressAddDialog() {
      this.mailingAddressForm = { ...this.initMailingAddressForm }
      this.mailingAddressForm.shipperVatNoType = SystemConstants.VAT_NO_VAT.code
      this.mailingAddressForm.consigneeVatNoType = SystemConstants.VAT_NO_VAT.code
      this.mailingAddressForm.notifyVatNoType = SystemConstants.VAT_NO_VAT.code
      this.mailingAddressMaintainDialog.isEdit = false
      this.mailingAddressMaintainDialog.title = this.$t('baseInfo.mailingAddress.addMailingAddress')
      this.mailingAddressMaintainDialog.isShow = true
    },
    syncFormatInfoToOrder(handleType) {
      switch (handleType) {
        case 'shipper':
          this.mailingAddressForm.shipperLine1 = this.mailingAddressForm.shipperEnterpriseName
          this.mailingAddressForm.shipperLine2 = this.mailingAddressForm.shipperAddress1
          this.mailingAddressForm.shipperLine3 = (this.mailingAddressForm.shipperCityCode +
            this.mailingAddressForm.shipperProvinceCode +
            this.mailingAddressForm.shipperCountryCode +
            this.mailingAddressForm.shipperZipCode)
          if (this.mailingAddressForm.shipperContactTel) this.mailingAddressForm.shipperLine4 = ('TEL:' + this.mailingAddressForm.shipperContactTel)
          break
        case 'consignee':
          this.mailingAddressForm.consigneeLine1 = this.mailingAddressForm.consigneeEnterpriseName
          this.mailingAddressForm.consigneeLine2 = this.mailingAddressForm.consigneeAddress1
          this.mailingAddressForm.consigneeLine3 = (this.mailingAddressForm.consigneeCityCode +
            this.mailingAddressForm.consigneeProvinceCode +
            this.mailingAddressForm.consigneeCountryCode +
            this.mailingAddressForm.consigneeZipCode)
          if (this.mailingAddressForm.consigneeContactTel) this.mailingAddressForm.consigneeLine4 = ('TEL:' + this.mailingAddressForm.consigneeContactTel)
          break
        case 'notify':
          this.mailingAddressForm.notifyLine1 = this.mailingAddressForm.notifyEnterpriseName
          this.mailingAddressForm.notifyLine2 = this.mailingAddressForm.notifyAddress1
          this.mailingAddressForm.notifyLine3 = (this.mailingAddressForm.notifyCityCode +
            this.mailingAddressForm.notifyProvinceCode +
            this.mailingAddressForm.notifyCountryCode +
            this.mailingAddressForm.notifyZipCode)
          if (this.mailingAddressForm.notifyContactTel) this.mailingAddressForm.notifyLine4 = ('TEL:' + this.mailingAddressForm.notifyContactTel)
          break
        default:
          break
      }
    },
    submitMailingAddress() {
      if (!this.checkMailingAddressForm()) {
        return
      }
      if (this.mailingAddressForm.lob.startsWith('FBA')) {
        this.mailingAddressForm.lob = this.mailingAddressForm.lob.split('FBA')[1]
      }
      this.mailingAddressForm.shipperProvinceName = this.mailingAddressForm.shipperProvinceCode
      this.mailingAddressForm.shipperCityName = this.mailingAddressForm.shipperCityCode
      this.mailingAddressForm.consigneeProvinceName = this.mailingAddressForm.consigneeProvinceCode
      this.mailingAddressForm.consigneeCityName = this.mailingAddressForm.consigneeCityCode
      this.mailingAddressForm.notifyProvinceName = this.mailingAddressForm.notifyProvinceCode
      this.mailingAddressForm.notifyCityName = this.mailingAddressForm.notifyCityCode
      if (this.mailingAddressMaintainDialog.isEdit) {
        this.editMailingAddress()
      } else {
        this.mailingAddressForm.officeId = this.$store.getters.currentOfficeId
        this.saveMailingAddress()
      }
    },
    cancelSaveOrEdit() {
      this.mailingAddressMaintainDialog.isShow = false
      this.mailingAddressForm = { ...this.initMailingAddressForm }
    },
    // 新增保存
    saveMailingAddress() {
      this.fullscreenLoading = getLoading()
      addMailingAddress(this.mailingAddressForm).then(() => {
        this.mailingAddressMaintainDialog.isShow = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.fetchMailingAddressList()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    popMailingAddressEditDialog() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length < 1) {
          self.$message.error(this.$t('common.tips.hasOneAtleast'))
        } else if (ids.length > 1) {
          self.$message.error(this.$t('common.tips.hasOneOnly'))
        } else {
          const uuid = getGridSelected(this.gridOptions)[0].uuid
          this.fullscreenLoading = getLoading()
          findMailingAddressByUuid({ uuid }).then(result => {
            const temp = { ...result.data }
            temp.shipperLine1 = ''
            temp.shipperLine2 = ''
            temp.shipperLine3 = ''
            temp.shipperLine4 = ''
            temp.consigneeLine1 = ''
            temp.consigneeLine2 = ''
            temp.consigneeLine3 = ''
            temp.consigneeLine4 = ''
            temp.notifyLine1 = ''
            temp.notifyLine2 = ''
            temp.notifyLine3 = ''
            temp.notifyLine4 = ''
            self.mailingAddressForm = temp
            self.mailingAddressForm.lob = 'FBA' + self.mailingAddressForm.lob
            self.mailingAddressMaintainDialog.isEdit = true
            self.mailingAddressMaintainDialog.title = self.$t('baseInfo.mailingAddress.editMailingAddress')
            self.mailingAddressMaintainDialog.isShow = true
          }).finally(() => {
            self.fullscreenLoading.close()
          })
        }
      })
    },
    // 编辑保存
    editMailingAddress() {
      this.fullscreenLoading = getLoading()
      updateMailingAddress(this.mailingAddressForm).then(() => {
        this.mailingAddressMaintainDialog.isShow = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.fetchMailingAddressList()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 保存前验证
    checkMailingAddressForm() {
      if (!this.mailingAddressForm.lob) {
        this.$message.warning(this.$t('baseInfo.mailingAddress.lobType') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      if (!this.mailingAddressForm.partnerId || Number(this.mailingAddressForm.partnerId) <= 0) {
        this.$message.warning(this.$t('baseInfo.mailingAddress.partner') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      // if (!this.mailingAddressForm.warehouseCode) {
      //   this.$message.warning(this.$t('baseInfo.mailingAddress.fbaWarehouseCode') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
      //   return false
      // }
      return true
    },
    // 客户属性过滤
    customerIdFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customer && item.fba && item.active
    }
  }
}
</script>

<style lang="scss" scoped>
.mailing-address{
  .input-w{
    width: 280px!important;
  }
  .tag-w{
    width: 100%!important;
  }
  .prefix-input::before{
    content: '+';
    position: absolute;
    left: -10px;
  }
  .expanded-div{
    position: relative;
    height: 550px;
  }
  .float-btn-wrapper{
    position: absolute;
    padding-bottom: 10px;
    bottom: 0;
  }
}
</style>
